// extracted by mini-css-extract-plugin
module.exports = {"d_horizontal":"StatusPanel_d_horizontal_2BG3d","btns":"StatusPanel_btns_3T45G","d_vertical":"StatusPanel_d_vertical_3xyx4"};